// extracted by mini-css-extract-plugin
module.exports = {"checkoutcontainer":"Checkout_checkoutcontainer__2YyLz","confirmation":"Checkout_confirmation__1rjO0"};